import { GraphQLClient } from "@refinedev/hasura";
import { auth } from "@auth/firebase/config";

const BACKEND_API_URL = import.meta.env.VITE_BACKEND_API_URL;
if (!BACKEND_API_URL) { 
  console.error("Environment VITE_BACKEND_API_URL is undefined, set in .env file.") 
}

export const backendClient = new GraphQLClient(BACKEND_API_URL, {
  headers: async () => {
    console.log('🔐 Getting headers for backend request');
    const user = auth.currentUser;
    console.log('👤 Current user:', user?.uid);
    
    if (user) {
      const token = await user.getIdToken();
      console.log('🎫 Token obtained:', token ? 'Yes' : 'No');
      const headers = {
        "Authorization": `Bearer ${token}`,
        "x-hasura-user-id": user.uid
      };
      console.log('📤 Sending headers:', headers);
      return headers;
    }
    console.log('❌ No user found, sending empty headers');
    return {};
  }
});